// src/layouts/freetext/freetext.tsx
import Richtext from "@a24/ui/Richtext";
import { jsx } from "react/jsx-runtime";
var Freetext = ({ className = "", text, id }) => {
  return /* @__PURE__ */ jsx("div", { className: `${className} max-md:mx-6 max-2xl:mx-16`, id, children: /* @__PURE__ */ jsx(Richtext, { text }) });
};
var freetext_default = Freetext;

export {
  freetext_default
};
